import {
  Backdrop,
  Checkbox,
  CircularProgress,
  Grid,
  Box,
  TextField,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material"
import React, { useEffect, useState } from "react"
import useStyles from "./useStyle"
import DatePicker from "react-datepicker"
import { es } from "date-fns/locale"
import DateRangeIcon from "@mui/icons-material/DateRange"
import MenuItem from "@mui/material/MenuItem"
import InfoIcon from "@mui/icons-material/Info"
import Select from "@mui/material/Select"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import {
  addGlobalNotification,
  getAllGlobalNotification,
  getAllNotificationTypes,
  setRequestTypes,
} from "../../../redux/actions/GlobalNotification"
import { useDispatch, useSelector } from "react-redux"
import { logEvent } from "../../../utils/LogEvents"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar,
} from "../../../redux/actions/app"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import { SelectSuborgGroups } from "./components/SelectSuborgGroups"
import { SelectNotificationConditions } from "./components/SelectNotificationConditions"
import { addEntityGroupGlobalNotification } from "../../../redux/actions/eAuthz"
import { getUserRoles } from "../../../utils/validateToken"

export const FormAddNotification = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [loading, setloading] = useState(false)
  const user = useSelector((state) => state.user)

  const { types } = useSelector((state) => state.globalNotification)
  const [selectedFinishDate, setselectedFinishDate] = useState(null)
  const [selectedStartDate, setSelectedStartDate] = useState(null)

  const [selectedStartDateSuspend, setSelectedSuspendStartDate] = useState(null)
  const [type, setType] = useState("")
  const [webappCheck, setwebappCheck] = useState(true)
  const [mobileApp, setmobileApp] = useState(true)
  const [title, setTitle] = useState("")
  const [text, setText] = useState("")
  const [startTime, setStartTime] = useState("")
  const [endTime, setEndTime] = useState("")
  const [startSuspendTime, setstartSuspendTime] = useState("")
  const [checkSuspendNotification, setCheckSuspendNotification] =
    useState(false)

  // const navigate = useNavigate()
  // inputs errors
  const [textError, settextError] = useState("")
  const [titleError, setTitleError] = useState(false)
  const [descriptionError, setdescriptionError] = useState(false)
  const [starDateError, setstarDateError] = useState(false)
  const [finishDateError, setfinishDateError] = useState(false)
  const [starDateSuspendError, setstarDateSuspendError] = useState(false)
  const [typeError, setTypeError] = useState(false)
  const [suborgGroupError, setsuborgGroupError] = useState(false)
  const [typeNotifCondError, settypeNotifCondError] = useState(false)
  const [plataformError, setplataformError] = useState(false)

  const [notificationCondSelect, setNotificationCondSelect] = useState("")
  const [suborganizationGroupSelect, setSuborganizationGroupSelect] =
    useState("")

  const handleChangeSuborgGroup = (event) => {
    setSuborganizationGroupSelect(event.target.value)
  }
  const handleChangeNotificationConditions = (event) => {
    setNotificationCondSelect(event.target.value)
  }

  const handleDateChange = (date) => {
    setselectedFinishDate(date)
  }

  const handleStartDateSuspendChange = (date) => {
    setSelectedSuspendStartDate(date)
  }

  const handleStartTimeChange = (time) => {
    setStartTime(time)
  }

  const handleEndTimeChange = (time) => {
    setEndTime(time)
  }

  const handleStartDateChange = (date) => {
    setSelectedStartDate(date)
  }

  const handleStartTimeSuspendChange = (time) => {
    setstartSuspendTime(time)
  }

  const handleChange = (event) => {
    setType(event.target.value)
    setCheckSuspendNotification(false)
  }

  const handleChange2 = () => {
    setwebappCheck(!webappCheck)
  }

  const handleChange3 = () => {
    setmobileApp(!mobileApp)
  }

  const children = (
    <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
      <FormControlLabel
        label="Mi Estudio Web"
        control={
          <Checkbox
            checked={webappCheck}
            onChange={handleChange2}
            style={{
              color: "#026873",
              "&.MuiChecked": {
                color: "#03A696",
              },
            }}
          />
        }
      />
      <FormControlLabel
        label="Mi Estudio Mobile"
        control={
          <Checkbox
            checked={mobileApp}
            onChange={handleChange3}
            style={{
              color: "#026873",
              "&.MuiChecked": {
                color: "#03A696",
              },
            }}
          />
        }
      />
    </Box>
  )

  const isDateWithinRange = (start, end, dateToCheckStart, dateToCheckEnd) => {
    const startDate = new Date(start)
    const endDate = new Date(end)
    const dateToCheckStartDate = new Date(dateToCheckStart)
    const dateToCheckEndDate = new Date(dateToCheckEnd)

    // return dateToCheckStartDate >= startDate && dateToCheckEndDate <= endDate

    // Fecha de inicio antes y termina después de la fecha original

    if (dateToCheckStartDate < startDate && dateToCheckEndDate > endDate) {
      return false
    }

    // fecha inicia antes de la fecha original y termina antes

    if (
      dateToCheckEndDate > startDate &&
      dateToCheckStartDate < startDate &&
      dateToCheckEndDate < endDate
    ) {
      return false
    }

    // fecha inicia después de la fecha original y termina después
    if (dateToCheckStartDate >= startDate && dateToCheckStartDate <= endDate) {
      return false
    }

    return true
  }

  const isValidate = () => {
    setTitleError(false)
    setdescriptionError(false)
    setstarDateError(false)
    setfinishDateError(false)
    setplataformError(false)
    setstarDateSuspendError(false)
    setsuborgGroupError(false)
    settypeNotifCondError(false)
    if (title === "") {
      settextError("Ingrese un título")
      setTitleError(true)
      return false
    }
    if (text === "") {
      settextError("Ingrese una descripción")
      setdescriptionError(true)
      return false
    }
    if (!selectedStartDate) {
      settextError("Ingrese la fecha y hora de inicio")
      setstarDateError(true)
      return false
    }
    if (!selectedFinishDate) {
      settextError("Ingrese la fecha y hora de finalización")
      setfinishDateError(true)
      return false
    }
    if (!type || type === "") {
      settextError("Seleccione el tipo de notificación")
      setTypeError(true)
      return false
    }
    if (!webappCheck && !mobileApp) {
      settextError("Seleccione la plataforma")
      setplataformError(true)
      return false
    }
    return true
  }

  const handleAddNotification = async () => {
    if (isValidate()) {
      const formatDateAndTime = (date, time) => {
        if (!date) return null
        const [hours, minutes] = time ? time.split(":") : ["00", "00"]
        const newDate = new Date(date)
        newDate.setHours(Number(hours))
        newDate.setMinutes(Number(minutes))
        newDate.setSeconds(0)

        return newDate.toISOString()
      }
      const formattedStartDate = formatDateAndTime(selectedStartDate, startTime)
      const formattedEndDate = formatDateAndTime(selectedFinishDate, endTime)

      try {
        const existingNotification = await dispatch(
          getAllGlobalNotification(["ME", "CGI"]),
        )

        if (existingNotification) {
          const isDuplicate = existingNotification.some(
            (notification) =>
              notification.notificationTypeCode === type &&
              notification.applicationCode === "ME" &&
              !isDateWithinRange(
                notification.validityStartDate,
                notification.validityFinishDate,
                formattedStartDate,
                formattedEndDate,
              ) &&
              notification.isActive === true,
          )

          if (isDuplicate) {
            dispatch(setRequestTextSnackBar())
            dispatch(setErrorTextSnackBar("Ya existe una notificación"))
            return
          }
        }

        const body = {
          notificationTitle: title,
          notificationText: text,
          communicationChannelCodes: [],
          validityStartDate: formattedStartDate,
          validityFinishDate: formattedEndDate || null,
          isActive: true,
          appCode: "ME",
          notificationTypeCode: type,
        }

        webappCheck && body.communicationChannelCodes.push("WEB-APP-PUSH")
        mobileApp && body.communicationChannelCodes.push("MOBILE-APP-PUSH")

        if (body.validityStartDate < body.validityFinishDate) {
          if (
            body.notificationTitle &&
            body.notificationText &&
            body.appCode &&
            body.notificationTypeCode &&
            body.communicationChannelCodes
          ) {
            const newNotification = await dispatch(addGlobalNotification(body))

            logEvent("CGI - addGlobalNotification", {
              body: {
                ...body,
              },
              response: newNotification,
            })

            if (!newNotification) {
              dispatch(setRequestTextSnackBar())
              dispatch(
                setErrorTextSnackBar(
                  "Ocurrió un error al crear la notificación",
                ),
              )
              return
            }
            let relatedNotificationId = newNotification?.notificationId
            if (
              (body.notificationTypeCode =
                "MAINTENANCE" && checkSuspendNotification)
            ) {
              if (!selectedStartDateSuspend) {
                settextError("Ingrese la fecha y hora de inicio")
                setstarDateSuspendError(true)
                return
              }

              const formattedSuspendStartDate = formatDateAndTime(
                selectedStartDateSuspend,
                startSuspendTime,
              )

              if (!(formattedSuspendStartDate < body.validityFinishDate)) {
                setstarDateSuspendError(true)
                return settextError(
                  "El servicio debe suspenderse antes a la fecha de finalización",
                )
              }

              if (formattedSuspendStartDate < body.validityStartDate) {
                setstarDateSuspendError(true)
                return settextError(
                  "El servicio debe suspenderse luego la fecha de inicio",
                )
              }

              console.log({
                ...body,
                relatedNotificationId,
                notificationTypeCode: "SERVICE_SUSPENSION",
                validityStartDate: formattedSuspendStartDate,
                validityFinishDate: body.validityFinishDate,
              })
              const newNotificationSuspend = await dispatch(
                addGlobalNotification({
                  ...body,
                  relatedNotificationId,
                  notificationTypeCode: "SERVICE_SUSPENSION",
                  validityStartDate: formattedSuspendStartDate,
                  validityFinishDate: body.validityFinishDate,
                }),
              )
              if (!newNotificationSuspend) {
                dispatch(setRequestTextSnackBar())
                dispatch(
                  setErrorTextSnackBar(
                    "Ocurrió un error al crear la notificación de suspensión relacionada",
                  ),
                )
                return
              }
              relatedNotificationId = newNotificationSuspend?.notificationId
            }
            if (
              (notificationCondSelect && notificationCondSelect !== "") ||
              (suborganizationGroupSelect && suborganizationGroupSelect !== "")
            ) {
              if (!notificationCondSelect || notificationCondSelect === "") {
                settypeNotifCondError(true)
                return settextError("Seleccione el tipo de condición")
              }
              if (
                !suborganizationGroupSelect ||
                suborganizationGroupSelect === ""
              ) {
                setsuborgGroupError(true)
                return settextError("Seleccione el grupo de estudios")
              }
              const asociateNotificationSuspend = await dispatch(
                addEntityGroupGlobalNotification({
                  notificationId: relatedNotificationId,
                  notificationConditionType: notificationCondSelect,
                  suborganizationGroupId: suborganizationGroupSelect,
                }),
              )
              console.log(asociateNotificationSuspend)
              if (!asociateNotificationSuspend) {
                dispatch(setRequestTextSnackBar())
                dispatch(
                  setErrorTextSnackBar(
                    "La notificación fue creada exitosamente, excepto la asociación del tipo de condición",
                  ),
                )
                return
              }
            }
            dispatch(setRequestTextSnackBar())
            dispatch(setSuccessTextSnackBar("Habilitación exitosa"))
            setTimeout(() => {
              window.location.href = "/globalNotification"
            }, 4000)
          }
        } else {
          dispatch(setRequestTextSnackBar())
          dispatch(
            setErrorTextSnackBar(
              "La fecha y horario de finalización deben ser posteriores a la de inicio",
            ),
          )
        }
      } catch (error) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error al crear la notificación"),
        )
      }
    }
  }

  const handleChangeSelectSuspendNotification = () =>
    setCheckSuspendNotification(!checkSuspendNotification)

  const loadTypes = async () => {
    setloading(true)
    await dispatch(getAllNotificationTypes())
    setloading(false)
  }

  const validateTypeByUserRole = (type, i) => {
    if (
      type.notificationTypeCode !== "ADVERTISEMENT" &&
      type.notificationTypeCode !== "INFORMATION" &&
      getUserRoles(user.eAuthToken).includes(
        "CGI.GlobalNotificationInfoOperator",
      )
    ) {
      return <></>
    }
    return (
      <MenuItem key={i} value={type.notificationTypeCode}>
        {type.notificationTypeDesc}
      </MenuItem>
    )
  }
  useEffect(() => {
    loadTypes()

    return () => {
      dispatch(setRequestTypes())
    }
  }, [])

  return (
    <div className={classes.boxDetails}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div style={{ width: "100%" }}>
        <Typography
          style={{
            fontSize: 24,
            fontWeight: "bold",
            color: "#4B4952",
            paddingLeft: 10,
            borderBottom: "1px solid rgba(36, 55, 143, 0.2)",
          }}
        >
          Datos de la nueva notificación
        </Typography>
      </div>
      <div style={{ padding: 10 }}>
        <div>
          <TextField
            id="standard-basic"
            label="Título"
            variant="standard"
            sx={{ width: "80%" }}
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            error={titleError}
            helperText={titleError && textError}
          />
        </div>

        <div style={{ paddingTop: 3 }}>
          <TextField
            style={{ width: "80%" }}
            id="standard-multiline-flexible"
            label="Contenido"
            multiline
            rows={3}
            variant="standard"
            value={text}
            onChange={(event) => setText(event.target.value)}
            error={descriptionError}
            helperText={descriptionError && textError}
          />
        </div>

        <div style={{ width: "100%" }}>
          <div>
            <Typography
              style={{
                color: "#6e7a76",
                padding: "10px 0px",
                fontFamily: "Roboto",
              }}
            >
              Fecha de inicio:
            </Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "5px 0px",
              }}
            >
              <DateRangeIcon sx={{ color: "#6e7a76", fontSize: "1.5em" }} />
              <div style={{ width: "100%", paddingLeft: 5 }}>
                <div style={{ display: "flex" }}>
                  <Typography sx={{ color: "#6e7a76", width: 80 }}>
                    Desde:
                  </Typography>

                  <DatePicker
                    id="date"
                    selected={selectedStartDate}
                    onChange={handleStartDateChange}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/mm/aaaa"
                    showYearDropdown
                    scrollableYearDropdown
                    className={classes.dateSelector}
                    locale={es}
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "5px 0px",
              }}
            >
              <AccessTimeIcon sx={{ color: "#6e7a76", fontSize: "1.5em" }} />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography
                  style={{
                    color: "#6e7a76",
                    marginLeft: 5,
                    fontFamily: "Roboto",
                    width: 80,
                  }}
                >
                  Horario:
                </Typography>
                <div>
                  <input
                    id="appt-time"
                    type="time"
                    name="appt-time"
                    value={startTime}
                    onChange={(event) =>
                      handleStartTimeChange(event.target.value)
                    }
                    style={{
                      height: "30%",
                      marginTop: "2.5%",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          {starDateError && (
            <Grid
              item
              xs={6}
              style={{
                display: "flex",
                paddingTop: 10,
                alignItems: "center",
                fontWeight: "bold",
                color: "#AD0707",
              }}
            >
              {textError}
            </Grid>
          )}
        </div>

        <div style={{ width: "100%" }}>
          <div>
            <Typography
              style={{
                color: "#6e7a76",
                padding: "5px 0px",
                fontFamily: "Roboto",
              }}
            >
              Fecha de finalización:
            </Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "5px 0px",
              }}
            >
              <DateRangeIcon sx={{ color: "#6e7a76", fontSize: "1.5em" }} />
              <div style={{ width: "100%", paddingLeft: 5 }}>
                <div style={{ display: "flex" }}>
                  <Typography sx={{ color: "#6e7a76", width: 80 }}>
                    Hasta:
                  </Typography>

                  <DatePicker
                    className={classes.dateSelector}
                    id="date"
                    selected={selectedFinishDate}
                    onChange={handleDateChange}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/mm/aaaa"
                    showYearDropdown
                    scrollableYearDropdown
                    locale={es}
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "5px 0px",
              }}
            >
              <AccessTimeIcon sx={{ color: "#6e7a76", fontSize: "1.5em" }} />
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <Typography
                  style={{
                    color: "#6e7a76",
                    marginLeft: 5,
                    fontFamily: "Roboto",
                    width: 80,
                  }}
                >
                  Horario:
                </Typography>
                <div>
                  <input
                    className={classes.timeSelector}
                    id="appt-time"
                    type="time"
                    name="appt-time"
                    value={endTime}
                    onChange={(event) =>
                      handleEndTimeChange(event.target.value)
                    }
                    style={{
                      height: "30%",
                      marginTop: "2.5%",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          {finishDateError && (
            <Grid
              item
              xs={6}
              style={{
                display: "flex",
                paddingTop: 10,
                alignItems: "center",
                fontWeight: "bold",
                color: "#AD0707",
              }}
            >
              {textError}
            </Grid>
          )}
        </div>
        <div container xs={12}>
          <div style={{ paddingTop: 3 }}>
            <Typography
              style={{
                color: "#6e7a76",
                marginTop: 10,
                marginBottom: 5,
                fontFamily: "Roboto",
              }}
            >
              Tipo de notificación:
            </Typography>
            <div style={{ display: "flex" }}>
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: 200,
                    color: "#00a78f",
                  }}
                >
                  <CircularProgress color="inherit" />
                </div>
              ) : (
                <>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={type}
                      onChange={handleChange}
                      label="Tipo"
                    >
                      <MenuItem value={""}></MenuItem>
                      {types &&
                        types.map((t, i) => validateTypeByUserRole(t, i))}
                    </Select>
                  </FormControl>
                  {type === "MAINTENANCE" && (
                    <div
                      style={{
                        display: "flex",
                        color: "#6e7a76",
                        alignItems: "center",
                        marginLeft: 15,
                      }}
                    >
                      <div>¿Es bloqueante?</div>
                      <Checkbox
                        checked={checkSuspendNotification}
                        onChange={handleChangeSelectSuspendNotification}
                        style={{
                          color: "#026873",
                          "&.MuiChecked": {
                            color: "#03A696",
                          },
                        }}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
            {typeError && (
              <div
                style={{
                  display: "flex",
                  paddingTop: 10,
                  alignItems: "center",
                  fontWeight: "bold",
                  color: "#AD0707",
                }}
              >
                {textError}
              </div>
            )}
          </div>
        </div>

        {type === "MAINTENANCE" && checkSuspendNotification && (
          <div style={{ width: "100%" }}>
            <div>
              <Typography
                style={{
                  color: "#6e7a76",
                  padding: "5px 0px",
                  fontFamily: "Roboto",
                }}
              >
                El servicio se suspenderá desde:
              </Typography>
              <div style={{ display: "flex" }}>
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0px",
                    }}
                  >
                    <DateRangeIcon
                      sx={{ color: "#6e7a76", fontSize: "1.5em" }}
                    />
                    <div style={{ width: "100%", paddingLeft: 5 }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ color: "#6e7a76", width: 80 }}>
                          Fecha:
                        </div>

                        <DatePicker
                          id="date"
                          selected={selectedStartDateSuspend}
                          onChange={handleStartDateSuspendChange}
                          dateFormat="dd/MM/yyyy"
                          placeholderText="dd/mm/aaaa"
                          showYearDropdown
                          scrollableYearDropdown
                          className={classes.dateSelector}
                          locale={es}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 0px",
                    }}
                  >
                    <AccessTimeIcon
                      sx={{ color: "#6e7a76", fontSize: "1.5em" }}
                    />

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          color: "#6e7a76",
                          marginLeft: 5,
                          fontFamily: "Roboto",
                          width: 80,
                        }}
                      >
                        Horario:
                      </div>

                      <div>
                        <input
                          id="appt-time"
                          type="time"
                          name="appt-time"
                          value={startSuspendTime}
                          onChange={(event) =>
                            handleStartTimeSuspendChange(event.target.value)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: 20,
                  }}
                >
                  <Tooltip
                    title={`El horario del inicio de la suspensión debe ser mayor al horario de fecha de inicio.
                    La suspensión finalizará en el misma fecha y horario que la fecha de finalización.`}
                  >
                    <IconButton>
                      <InfoIcon style={{ color: "#696564", fontSize: 40 }} />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
              {starDateSuspendError && (
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    paddingTop: 10,
                    alignItems: "center",
                    fontWeight: "bold",
                    color: "#AD0707",
                  }}
                >
                  {textError}
                </Grid>
              )}
            </div>
          </div>
        )}

        {type && type !== "" && (
          <div style={{ width: "100%" }}>
            <Typography
              style={{
                color: "#6e7a76",
                marginTop: 10,
                marginLeft: 5,
                marginBottom: 5,
                fontFamily: "Roboto",
              }}
            >
              Tipo de condición:
            </Typography>
            <SelectNotificationConditions
              notificationCondSelect={notificationCondSelect}
              handleChange={handleChangeNotificationConditions}
            />
            {typeNotifCondError && (
              <Grid
                item
                xs={6}
                style={{
                  display: "flex",
                  paddingTop: 10,
                  alignItems: "center",
                  fontWeight: "bold",
                  color: "#AD0707",
                }}
              >
                {textError}
              </Grid>
            )}
            <Typography
              style={{
                color: "#6e7a76",
                marginTop: 10,
                marginLeft: 5,
                marginBottom: 5,
                fontFamily: "Roboto",
              }}
            >
              Grupos de estudios:
            </Typography>
            <SelectSuborgGroups
              suborganizationGroupSelect={suborganizationGroupSelect}
              handleChange={handleChangeSuborgGroup}
            />
            {suborgGroupError && (
              <Grid
                item
                xs={6}
                style={{
                  display: "flex",
                  paddingTop: 10,
                  alignItems: "center",
                  fontWeight: "bold",
                  color: "#AD0707",
                }}
              >
                {textError}
              </Grid>
            )}
          </div>
        )}

        <Grid item xs={8} style={{ paddingTop: 3 }}>
          <Typography
            style={{
              color: "#6e7a76",
              marginTop: 10,
              marginLeft: 5,
              marginBottom: 5,
              fontFamily: "Roboto",
            }}
          >
            Aplicación:
            <FormControlLabel
              label="ME"
              control={
                <Checkbox
                  size="small"
                  disabled
                  checked
                  value="ME"
                  style={{
                    marginLeft: "10%",
                    color: "#696564",
                    "&.MuiChecked": {
                      color: "#696564",
                    },
                  }}
                />
              }
            />
          </Typography>
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 3 }}>
          <Typography
            style={{
              color: "#6e7a76",
              marginTop: 10,
              marginLeft: 5,
              marginBottom: 5,
              fontFamily: "Roboto",
            }}
          >
            Canal de comunicación:
            {children}
          </Typography>
        </Grid>
        {plataformError && (
          <Grid
            item
            xs={6}
            style={{
              display: "flex",
              paddingTop: 10,
              alignItems: "center",
              fontWeight: "bold",
              color: "#AD0707",
            }}
          >
            {textError}
          </Grid>
        )}
      </div>
      <Box className={classes.buttons}>
        <ButtonConfirm handleAddNotification={handleAddNotification} />
      </Box>
    </div>
  )
}

function ButtonConfirm({
  showCircularProgress,
  isError,
  handleAddNotification,
}) {
  const classes = useStyles()
  const [isProgressComplete, setProgressComplete] = useState(false)

  const handleButtonClick = async () => {
    if (!showCircularProgress && !isError) {
      try {
        await handleAddNotification()
        setProgressComplete(true)
      } catch (error) {}
    }
  }

  useEffect(() => {
    if (isError) {
      setProgressComplete(false)
    }
  }, [isError])

  return (
    <div>
      <button
        className={`${classes.confirmButton} ${
          isProgressComplete ? classes.disabledButton : ""
        }`}
        disabled={isProgressComplete && showCircularProgress}
        onClick={handleButtonClick}
      >
        {showCircularProgress ? (
          <CircularProgress size="1.5rem" color="inherit" />
        ) : (
          <Typography
            className={classes.confirmButtonTypography}
            variant="contained"
          >
            CREAR
          </Typography>
        )}
      </button>
    </div>
  )
}
